import { useState, useEffect, useContext } from 'react';
import { useSearchParams, useLoaderData } from 'react-router';

import { fixedValues, clearString } from 'src/util/Util';
import SearchContext from 'src/context/SearchContext';


const EMenu = () => {
    const { temas } = useLoaderData();
    const [ searchParams ] = useSearchParams();
    const { setOpenMenu, updateParams } = useContext(SearchContext);
    const [ tema, setTema ] = useState(searchParams.get('metadata.dc_subject')?.trim());

    const selectMenu = (subject) => {
        setTema(t => t === subject ? null : subject )
    }

    const updateSP = () => {
        if ((tema || null) !== (searchParams.get('metadata.dc_subject') || null)) { // consideramos null = undefined
            if (tema) searchParams.set('metadata.dc_subject', tema)
            else searchParams.delete('metadata.dc_subject')
            updateParams(searchParams);
        }
    }

    useEffect(() => {
        updateSP();
    }, [tema]);

    return (
        <div className="emenu">
            <div className="menu-title">Temas</div>
            {fixedValues.dc_subject.map((fv, i) => {
                let selectTema = clearString(tema) === clearString(fv);
                let present = temas?.find(t => clearString(fv) === clearString(t.key))
                return ( <button key={'menu-item-' + i}
                    className={`menu-item ${ selectTema ? 'ico-f3e selected' : ''}`}
                    onClick={() => selectMenu(fv)}
                    disabled={!present}
                    data-text={fv}
                >
                    <span>{fv}</span>
                    <span>{present?.doc_count}</span>
                </button> )
            }) }
        </div>
    );
};


export default EMenu
